// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3641":"07f9cb8406f9b4a4","9721":"90d1c0a50e05a62a"}[chunkId] + ".css";
};